import { readUserSettingsTable } from '.';
import { getOwnerID } from '../../utils/DryCookies';
import logger from '../../logger';
import { HasUserSettingsLocalDatabaseContentType } from '../../types/userSettings';

export const checkUserSettingsLocalDatabaseContent = async () => {
  console.log('hasUserSettingsLocalDatabaseContent');
  const ownerId = getOwnerID() as string;
  let hasUserSettingsLocalDatabaseContent = false as HasUserSettingsLocalDatabaseContentType;
  if (!ownerId) {
    logger.info('Local database content NOT FOUND');
    return {
      hasUserSettingsLocalDatabaseContent,
    };
  }

  try {
    const userSettingsLocalDatabaseContent = await readUserSettingsTable();
    logger.debug({ userSettingsLocalDatabaseContent }, 'readUserSettingsTable content returned');
    hasUserSettingsLocalDatabaseContent = Boolean(Object.keys(userSettingsLocalDatabaseContent).length);

    logger.debug({ hasUserSettingsLocalDatabaseContent }, 'readUserSettingsTable content returned');
    // Return the actual settings object so the requiredAppDataState handler can
    // populate context.userSettings from IndexedDB without a cloud fetch.
    // Previously only the boolean flag was returned, causing context.userSettings
    // to stay null on every refresh with local data and forcing a cloud round-trip.
    return {
      hasUserSettingsLocalDatabaseContent,
      userSettings: hasUserSettingsLocalDatabaseContent ? userSettingsLocalDatabaseContent : null,
    };
  } catch (error) {
    logger.error(error, 'Local database content NOT FOUND');
    return {
      hasUserSettingsLocalDatabaseContent,
      userSettings: null,
    };
  }
};
